import { render } from "./AstOrganisationsdaten.pug?vue&type=template&id=3e34d1c6&lang=pug"
import script from "./AstOrganisationsdaten.js?vue&type=script&lang=js"
export * from "./AstOrganisationsdaten.js?vue&type=script&lang=js"

import "./AstOrganisationsdaten.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__